import { Component } from '@angular/core';
import { TFMService } from 'app/mock-api/tfm.service';
import { Title, Meta } from '@angular/platform-browser';

import { AboutType03Component } from './about-type03/about-type03.component';
import { AboutType01Component } from './about-type01/about-type01.component';
import { AboutType02Component } from './about-type02/about-type02.component';
import { AboutType04Component } from './about-type04/about-type04.component';
import { AboutType05Component } from "./about-type05/about-type05.component";

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [AboutType01Component, AboutType02Component, AboutType03Component, AboutType04Component, AboutType05Component],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {

   public view: any = {

  };

  constructor( private _tfmService : TFMService, private title: Title, private metaService: Meta) {  }

   ngOnInit(): void {
    this._tfmService.getSite().then(res => {
      this.view.site = res;

      if(this.view.site) {
        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        this._tfmService.log(this.view);
      }
    });

    this._tfmService.getContentBySection('about').then(res => {
      this.view.page = res;

      if (this.view.page && this.view.site) {

        //Set title
        this.title.setTitle(this.view.page.content.name + " - " + this.view.site.name);

        // Set description & keywords
        this.metaService.updateTag( { name:'description', content:this.view.page.content.seo.description});
        this.metaService.updateTag( { name:'keywords', content:this.view.page.content.seo.keywords});
      }
    });

  }

}
